export class OfflineMessageToChatRequiredProperties {
  offlineObj = new OfflineNewVersionProperties();
  type: string;
  success: boolean;
}

export class OfflineNewVersionProperties {
  offlineId: number;
  offlineRequestType: number;
  offlineRequestTypeName: string;
  requestingAgency: string;
  resquestingUser: number;
  requestingUserName: string;
  bookingStatusName: string;
  currentBookingStatus: number;
  previousBookingStatus: number;
  inProgressTag: boolean;
  assignedUser: number;
  sector: string;
  tripType: string;
  isGds: boolean | null;
  isLcc: boolean | null;
  isDirect: boolean | null;
  isNearByAirport: boolean | null;
  fareType: string;
  cabinClass: string;
  lastActivityTime: string;
  adult: number;
  child: number;
  infant: number;
  prefferedAirlines: string[];
  sectorInfo: OfflineSectorInformationNewVersion[];
  passengerList: OfflinePassengerListProperties[];
  isDeleted: boolean | null;
  issuingAirline: string = "";
  pnr: string = "";
  refundType: string = "";
  remarks: string = "";
  bookingSource: string = "";
  isManager: boolean = false;
  isReissue: boolean = false;
  pcc: string = "";
  reissueObj = new OfflineNewVersionReIssue();
}

export class OfflinePassengerListProperties {
  passengerId: number = 0;
  type: string = "";
  ticketNo: string = "";
  fullName: string = "";
  isDeleted: boolean = false;
}

export class OfflineSectorInformationNewVersion {
  offlineSectorId: number;
  fromCity: string;
  toCity: string;
  fromAirport: string;
  toAirport: string;
  departureDate: string;

  isReturn: boolean;
  isDeleted: boolean;
}
export class OfflineStatusNewVersion {
  name: string;
  id: number;
}
export enum OfflineActionEnum {
  Ticketed = 3,
  Booked = 4,
  Invoiced = 5,
  RemovedFromList=6,
}
export enum OfflineRequestTypeEnum {
  OfflineBookingGroupRequest = 2,
  OfflineTicketRequest = 3,
  OfflineVoidRequest = 4,
  OfflineRefundRequest = 5,
  OfflineReissueRequest = 16,
  OnlineTicketRequest = 7,
  OnlineVoidRequest = 8,
  OnlinePNRCancelRequest = 12,
  OnlineRefundRequest = 14,
  OnlineImportPNRTicketRequest = 15,


}
export enum OfflineNewVersionBookingStatus {
  Requested = 1,
  InProgress = 2,
  Ticketed = 3,
  Booked = 4,
  Invoiced = 5,
  RemovedFromList = 6
} 
export class OfflineNewVersionReIssue {
  previousTicketNo: string = "";
  pnr: string = "";
  departureDate: string = "";
}
export enum OfflineTypesMainEnum {
  Booking = 1,
  Ticket = 2,
  Resissue = 3,
  Refund = 4,
  Void = 5
}
export class OfflineBookingSourceProperties {
  OfflineSourceId: number = 0;
  OfflineSourceName: string = "";
 }
